$ = require('jquery');

"use strict";

var PLUGIN_NAME = "jspagination";

var DEFAULTS = {
	pageSize: 6,
	itemSelector: '',
	nextButtonSelector: '',
	autoPreloadHistory: true,
	onAfterShowPage: function() {}
};

// The actual plugin constructor
function JsPagination(element, options) {
	this.element = element;
	this.$t = $(this.element);

	this.options = $.extend(true, {}, DEFAULTS, options);

	this._defaults = DEFAULTS;
	this._name = PLUGIN_NAME;

	this._items = [];
	this._pagesCount = 0;
	this._actualPage = 0;

	this._initialise();
}

/**
 * init
 */
JsPagination.prototype._initialise = function() {
	this._items = this._getData();

	if (this._items.size() == 0) {
		$(this.options.nextButtonSelector).remove();
		return false;
	}

	if (this._items.size() <= this.options.pageSize) {
		this._items.each(function(index, item) {
			$(item).show();
		});
	}

	if (this.options.autoPreloadHistory && history.replaceState && history.state && history.state.pageId) {
		this._loadPageFromHistory();
	}

	this._showPage(this._actualPage);
	this._bindNextButtonEvent();

	if (this.options.autoPreloadHistory && history.replaceState && history.state && history.state.pageId && parseInt(history.state.pageId) > 0) {
		$('html, body').animate({ scrollTop: this.$t.offset().top }, 200);
	}

	console.log(this);

};

/**
 * get item array from generated HTML
 */
JsPagination.prototype._getData = function() {
	var $items = $(this.options.itemSelector, this.$t);
	this._pagesCount = parseInt($items.size() / this.options.pageSize);
	if ($items.size() % this.options.pageSize !== 0) {
		this._pagesCount = this._pagesCount + 1;
	}
	return $items;
};

/**
 * show items up to page id
 * @param id
 * @private
 */
JsPagination.prototype._showPage = function(id) {
	var lastVisibleItem = id * this.options.pageSize + this.options.pageSize;

	$.each(this._items, function(index, item) {
		if (index < lastVisibleItem) {
			$(item).show();
		}
	});

	this.options.onAfterShowPage.call(this);
	this._updateNextButton();
	if (this.options.autoPreloadHistory) {
		this._saveStateToHistory(this._actualPage);
	}
};

/**
 * bind next page event
 * @private
 */
JsPagination.prototype._bindNextButtonEvent = function() {
	var _self = this;
	$(this.options.nextButtonSelector).show().on('click', function(e) {
		e.preventDefault();
		_self.setActualPage(++_self._actualPage);
		_self._showPage(_self._actualPage);
		$(e.currentTarget).focusout();
	});
};

/**
 * hides next button when there are no more items
 * @private
 */
JsPagination.prototype._updateNextButton = function() {
	if ((this._actualPage + 1) == this._pagesCount) {
		$(this.options.nextButtonSelector).remove();
	}
};

/**
 * save actualPage to HTML5 history
 * @private
 */
JsPagination.prototype._saveStateToHistory = function(pageId) {
	if (history.replaceState) {
		history.replaceState({ pageId: pageId}, document.title, window.location.href);
	}
};

/**
 * reads pageId from history and loads actual page
 * @private
 */
JsPagination.prototype._loadPageFromHistory = function() {
	if (history.replaceState && history.state && history.state.pageId) {
		this.setActualPage(history.state.pageId);
	}
};

/**
 * public method to set actual page - from HTML5 history
 * @param pageIndex
 */
JsPagination.prototype.setActualPage = function(pageIndex) {
	this._actualPage = pageIndex;
};

/**
 * decide, which methods will be "public"
 */
var API = {
	setActualPage: JsPagination.prototype.setActualPage
};

/**
 * plugin go live
 * @param value - first param - decides, which action shall be executed
 *         if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
 *         if string && in API object - run method named as this value with all args[index > 0]
 * @return {*}
 */
$.fn[PLUGIN_NAME] = function(value) {
	var args = arguments;

	return this.each(function() {
		var $this = $(this);

		// get plugin instance
		var plugin = $this.data('plugin_' + PLUGIN_NAME);

		// if there's not, create one
		if (!plugin) {
			plugin = new JsPagination(this, value);
			$this.data('plugin_' + PLUGIN_NAME, plugin);
		}
		// if there is and first parameter is in predefined API methods, call it with rest of params
		else if (API[value]) {
			plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
		}
	});
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.jspagination.js